import PropTypes from 'prop-types';

export default function Radio({ callback, checked = false, id, label, name, testId = '', value }) {
	return (
		<div className="form-field" data-field-type="radio">
			<div className="form-binary-input">
				<input type="radio" name={name} id={id} value={value} onChange={callback} checked={checked} data-testid={testId} />
				<label htmlFor={id}>{label}</label>
			</div>
		</div>
	);
}

Radio.propTypes = {
	callback: PropTypes.func.isRequired,
	checked: PropTypes.bool,
	id: PropTypes.string,
	label: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	testId: PropTypes.string,
	value: PropTypes.string.isRequired,
};
